import FilterMinResolution from './filterMinResolution'

export default FilterMinResolution
